import { datetimeFormat, dateFormatWithUnit } from '@/utils/datetimeFormat'

export default {
  install(Vue) {
    Vue.filter('datetimeFormat', datetimeFormat)
    Vue.filter('dateFormatWithUnit', dateFormatWithUnit)
  },
}
